import { useCallback } from 'react';

import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { BillingPlan, BillingPlanWrite, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useCreateBillingPlan(): UseMutationResult<
  AxiosResponse<BillingPlan>,
  AxiosError<ErrorMessage>,
  BillingPlanWrite
> {
  const queryClient = useQueryClient();

  const createBillingPlan = useCallback(
    (billingPlan: BillingPlanWrite): Promise<AxiosResponse<BillingPlan>> => {
      return client.post('billing-plans/', billingPlan);
    },
    [],
  );

  return useMutation(createBillingPlan, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['packages'],
      });
    },
  });
}
